import { render, staticRenderFns } from "./TherapistManagement.vue?vue&type=template&id=26d432f4&"
import script from "./TherapistManagement.vue?vue&type=script&lang=js&"
export * from "./TherapistManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports